import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { WarnModal } from '@/components/elements';
import { useAuthorization } from '@/modules/user/hooks';

interface Props {
  onSetVisible: (value: boolean) => void;
}

const ChangePasswordSuccessModal: React.FC<Props> = ({ onSetVisible }) => {
  const { t } = useTranslation();
  const { handleLogout } = useAuthorization();

  const handleSubmit = useCallback(() => {
    onSetVisible(false);
    handleLogout();
  }, [onSetVisible, handleLogout]);

  useEffect(() => {
    return () => {
      handleSubmit();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <WarnModal
      testId="password-successfully-changed"
      visible
      isSuccessIcon
      onSetVisible={onSetVisible}
      header={t('Password Was Successfully Changed')}
      submitButtonText={t('Go Back to Sign In')}
      onSubmit={handleSubmit}
    />
  );
};

export default ChangePasswordSuccessModal;
